import React from 'react';
import { Calendar, Globe, Monitor } from 'lucide-react';
import { FilterDef, FilterOption, SortDef } from '@/components/shared/filters';
import { DefaultSort } from '@/components/shared/filters';

/** Date-created options. Values map directly to the `/leads/` date_range param. */
export const LEADS_DATE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All Dates' },
  { value: 'today', label: 'Today' },
  { value: 'last_3_days', label: 'Last 3 Days' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'last_90_days', label: 'Last 90 Days' },
  { value: 'last_year', label: 'Last Year' },
];

/**
 * Contacts filter registry. URL params map straight onto the `/leads/`
 * endpoint query params: date_range, source.
 */
export const LEADS_FILTERS: FilterDef[] = [
  {
    id: 'date',
    label: 'Date Created',
    icon: <Calendar className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'date_range',
    pinned: true,
    options: LEADS_DATE_OPTIONS,
  },
  {
    id: 'source',
    label: 'Source',
    icon: <Globe className="h-3.5 w-3.5" />,
    type: 'select',
    urlParam: 'source',
    options: [
      { value: 'all', label: 'All Sources' },
      { value: 'website', label: 'Website', icon: <Globe className="h-3.5 w-3.5 text-green-500" /> },
      { value: 'app', label: 'App', icon: <Monitor className="h-3.5 w-3.5 text-blue-500" /> },
    ],
  },
];

/** Sortable columns (ids match the table column accessorKeys). */
export const LEADS_SORTS: SortDef[] = [
  { id: 'email', label: 'Email', field: 'email', defaultOrder: 'asc' },
  { id: 'first_name', label: 'First Name', field: 'first_name', defaultOrder: 'asc' },
  { id: 'last_name', label: 'Last Name', field: 'last_name', defaultOrder: 'asc' },
  { id: 'company', label: 'Company', field: 'company', defaultOrder: 'asc' },
  { id: 'revenue', label: 'Revenue', field: 'revenue', defaultOrder: 'desc' },
  { id: 'source', label: 'Source', field: 'source', defaultOrder: 'asc' },
  { id: 'created_at', label: 'Date Created', field: 'created_at', defaultOrder: 'desc' },
];

export const LEADS_DEFAULT_SORT: DefaultSort = { field: 'created_at', order: 'desc' };
